var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"data-wa-source":_vm.source,"target":"_blank","rel":"noopener","aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("Message us on WhatsApp")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }